module.exports = __webpack_public_path__ + "img/b_immun_back.38a6d3c5.jpeg";